export function useValidateContact(modelValue, tile) {

    if (tile === 'shipper') return !!(modelValue.shipper.shipperContactFirstName && modelValue.shipper.shipperContactLastName);

    if (tile === 'consignee') return !!(modelValue.consignee.consigneeContactFirstName && modelValue.consignee.consigneeContactLastName);

}
